// extracted by mini-css-extract-plugin
export default {"subHeader":"SubHeader_subHeader__l3h7g","subHeadingText":"SubHeader_subHeadingText__AMMB3"};